import { Component, createRef } from "react";
import { getFileData } from "../utils";
import Close from "@mui/icons-material/Close";
import ReactCrop, { centerCrop, makeAspectCrop, } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { IconButton } from "@mui/material";
import Edit from "@mui/icons-material/Edit";
import Done from "@mui/icons-material/Done";

function centerAspectCrop(mediaWidth, mediaHeight, aspect=1) {

   console.log({
      mediaWidth,
      mediaHeight,
      aspect,
   })

   return centerCrop(
      makeAspectCrop(
         {
            unit: 'px',
            width: Math.min(mediaWidth, 100),
         },
         aspect,
         mediaWidth,
         mediaHeight
      ),
      mediaWidth,
      mediaHeight
   )
}


export default class ImageInput extends Component {

   state = {
      file: null,
      crop: null,
      zoom: 1,
   }

   imgRef = createRef();
   inputRef = createRef();

   handleFileChange = async (event) => {
      const file = await getFileData(event.target.files[0]);
      this.setState({ file });
   }

   save = async () => {
      const img = this.imgRef.current;
      const { crop } = this.state;

      const scaleX = img.naturalWidth / img.width;
      const scaleY = img.naturalHeight / img.height;

      const croppedImgWidth = crop.width * scaleX;
      const croppedImgHeight = crop.height * scaleY;

      const canvas = document.createElement('canvas');
      document.body.appendChild(canvas);
      
      canvas.width = croppedImgWidth;
      canvas.height = croppedImgHeight;
      const ctx = canvas.getContext('2d');
    
      const cropX = crop.x * scaleX;
      const cropY = crop.y * scaleY;

      ctx.drawImage(
        img,
        cropX,
        cropY,
        croppedImgWidth,
        croppedImgHeight,
        0,
        0,
        croppedImgWidth,
        croppedImgHeight
      )

      const url = canvas.toDataURL('image/png', 1);
      const base64 = url.split(',')[1];
      
      this.props.onClose({
         base64,
         ext: 'png',
      });

   }

   openFilePicker = () => {
      this.inputRef.current.click();
   }

   render() {

      let jsx;
      const { file } = this.state;
      const { aspectRatio=1 } = this.props;

      if (file) {
         jsx = <>
            <ReactCrop
               crop={this.state.crop}
               onChange={(crop) => this.setState({ crop })}
               aspect={aspectRatio}
               circularCrop={this.props.circularCrop}
               minWidth={100}
               className="bg-white"
            >
               <img
                  src={file.url}
                  alt="Crop me"
                  ref={this.imgRef}
                  onLoad={() => {
                     const { width, height } = this.imgRef.current;
                     const crop = centerAspectCrop(width, height, aspectRatio);
                     this.setState({ crop });
                  }}
               />
            </ReactCrop>
            <div className="flex justify-between px-4 gap-2 mt-2">
               <IconButton
                  onClick={this.openFilePicker}
                  className="text-white"
               >
                  <Edit />
               </IconButton>
               <IconButton
                  variant="contained"
                  onClick={this.save}
                  className="bg-orange-500 text-white"
               >
                  <Done />
               </IconButton>
            </div>
         </>
      } else {
         jsx = <div className="h-full bg-gray-200 rounded-lg p-8">
            <div
               className="h-full flex items-center justify-center bg-white border-2 border-dashed rounded-lg border-orange-400 tex-sm text-gray-600 cursor-pointer"
               onClick={this.openFilePicker}
               style={{
                  aspectRatio
               }}
            >
               Click to select a file
            </div>
         </div>
      }

      return <div className="fixed inset-0 bg-[#000E] z-50 flex items-center justify-center ">
         <div className="w-[400px] aspect-square">
            {jsx}
         </div>
         <IconButton className="absolute top-2 right-2 text-white" onClick={() => this.props.onClose()}>
            <Close />
         </IconButton>
         <input
            type="file"
            accept="image/*"
            onChange={this.handleFileChange}
            id="file-input"
            className="hidden"
            ref={this.inputRef}
         />
      </div>
   }
}